import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=60587d6f&scoped=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"
import style0 from "./Help.vue?vue&type=style&index=0&id=60587d6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60587d6f",
  null
  
)

export default component.exports